import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faShoppingCart } from "@fortawesome/free-solid-svg-icons";
import "./FloatingCart.css"; // 🔥 importa el CSS del botón

const FloatingCart = ({ cartItems = [], totalPrice = 0, moneda = "USD", openModal }) => {
    return (
        <div className="floating-cart-wrapper">
            <button className="floating-cart-button" onClick={openModal}>
                <FontAwesomeIcon icon={faShoppingCart} className="fc-icon" />
                {cartItems.length > 0 && <span className="fc-count">{cartItems.length}</span>}
                {cartItems.length > 0 && (
                    <>
                        <span className="fc-text">Mirar orden</span>
                        <span className="fc-price">{moneda} {totalPrice.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")}</span>
                    </>
                )}
            </button>

        </div>
    );
};

export default FloatingCart;